const params = new URLSearchParams(window.location.search);

const contact = params.get('contact');
const orderNo = params.get('orderNo');

const locale = Shopify.locale === "vi" ? {
  pending: "Đã đặt hàng",
  packed: "Đã đóng gói",
  handed_over: "Đang vận chuyển",
  completed: "Hoàn thành",
  canceled: "Đã hủy",
  fail_delivery: "Giao hàng thất bại",
  returned: "Trả hàng",
  home_delivery: "Giao hàng tận nơi",
  store_pickup: "Nhận tại cửa hàng",
  shipping_provider: "Đơn vị vận chuyển",
  tracking_number: "Mã vận đơn",
  updating: "Đang cập nhật",
  method_cod: "Thanh toán khi nhận hàng",
  method_manual: "Thanh toán trực tuyến",
  method_onepay: "Thanh toán qua cổng Onepay",
  method_installment: "Thanh toán trả góp",
  method_zalopay: "Thanh toán qua cổng Zalo Pay",
  method_momo: "Thanh toán qua ví điện tử Momo",
  not_found_message: "Không tìm thấy đơn hàng với thông tin đã cung cấp. Vui lòng kiểm tra lại.",
  not_support_message: "Chưa hỗ trợ tra cứu với đơn hàng Click&Collect nhận tại nhiều cửa hàng. Vui lòng liên hệ hotline để được hỗ trợ.",
} : {
  pending: "Ordered",
  packed: "Packed",
  handed_over: "In transit",
  completed: "Delivered",
  canceled: "Canceled",
  fail_delivery: "Failed to deliver",
  returned: "Return",
  home_delivery: "Home delivery",
  store_pickup: "Pickup at",
  shipping_provider: "Shipping provider",
  tracking_number: "Tracking number",
  updating: "Updating",
  method_cod: "Cash on Delivery",
  method_manual: "Online Payment",
  method_onepay: "Payment via Onepay Gateway",
  method_installment: "Installment Payment",
  method_zalopay: "Payment via Zalo Pay Gateway",
  method_momo: "Payment via Momo e-wallet",
  not_found_message: "Could not find an order with the provided information. Please check again.",
  not_support_message: "Not yet supported for tracking Click&Collect orders picked up at multiple stores. Please contact the hotline for assistance.",
}

const statusContent = [
  {
    status: "pending,ready_to_ship",
    showText: locale.pending
  },
  {
    status: "picked,packed",
    showText: locale.packed
  },
  {
    status: "handed_over",
    showText: locale.handed_over
  },
  {
    status: "completed",
    showText: locale.completed
  },
  {
    status: "canceled",
    showText: locale.canceled
  },
  {
    status: "fail_delivery",
    showText: locale.fail_delivery
  },
  {
    status: "returned",
    showText: locale.returned
  },
];

const apiUrl = "/apps/tra-cuu-don-hang/?v=1";
function getOrder(contact, orderNo) {
    const body = contact.includes("@") ? {
        email: contact,
        orderId: orderNo,
    } : {
        phone: contact,
        orderId: orderNo,
    };
    return fetch(apiUrl, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
    })
    .then(response => response.json())
    .then(data => {
        return data;
    })
    .catch(error => {
        console.error("Error fetching order:", error);
        throw error;
    });
}

function formatTo12HourTime(dateString) {
  if (!dateString) {
    return {
      date: '',
      time: '',
      dateTime: ''
    };
  }

  const options12h = {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  };

  const options24h = {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  };

  if (dateString.includes("T")) {
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    const finalDate = `${day}/${month}/${year}`;
    const finalTime12h = date.toLocaleTimeString('en-US', options12h);
    const finalTime24h = date.toLocaleTimeString('en-GB', options24h);

    return {
      date: finalDate,
      time: finalTime12h,
      dateTime: `${finalDate} | ${finalTime12h}`,
      dateTime24h: `${finalDate} - ${finalTime24h}`
    };
  } else {
    const [datePart, timePart] = dateString.split(" ");
    const [day, month, year] = datePart.split("/");
    const [splittedHours, splittedMinutes] = timePart.split(":");
  
    const date = new Date(year, month - 1, day, splittedHours, splittedMinutes);
    const finalTime12h = date.toLocaleTimeString('en-US', options12h);
    const finalTime24h = date.toLocaleTimeString('en-GB', options24h);

    return {
      date: datePart,
      time: finalTime12h,
      dateTime: `${datePart} | ${finalTime12h}`,
      dateTime24h: `${datePart} - ${finalTime24h}`
    };
  }
}

const formatPrice = (money) => {
  let formattedPrice = new Intl.NumberFormat('en-US').format(money.amount);
  if (money.currencyCode === "VND") {
    formattedPrice = formattedPrice + 'đ';
  } else {
    formattedPrice = formattedPrice + money.currencyCode;
  }
  return formattedPrice;
}

const matchedStatus = (currentStatusValue, deliveryType) => {
  if (deliveryType === "store_pickup") {
    return statusContent.find((item) => item.status.includes(currentStatusValue));
  } else if (deliveryType === "home_delivery") {
    return statusContent.slice().reverse().find(item =>
      item.status.includes(currentStatusValue)
    );
  }
}
const statusObject = (status, response) => response?.find((item) => item.curent_status.includes(status));

function maskData(value, type) {
  if (!value || typeof value !== 'string') return value;

  switch (type) {
    case 'name':
      if (value.length < 2) return value;
      return value[0] + '*'.repeat(value.length - 2) + value[value.length - 1];

    case 'phone':
      if (value.length < 6) return value;
      return value.slice(0, 3) + '*'.repeat(value.length - 6) + value.slice(-3);

    case 'address':
      if (value.length < 6) return value;
      return '*'.repeat(Math.min(value.length, 25));

    case 'partialAddress':
      const index = value.indexOf(' ');
      return index === -1 ? value : value.slice(0, index);

    default:
      return value;
  }
}

const convertToSlug = (text) => {
  return !!text 
    ? text
      .replace(/\s+/g, '')
      .replace(/^0/, '')
      .replace(/^\+84/, '')
    : "";
}

async function fetchOrder(contact, orderNo) {
  try {
    const wholeSection = document.querySelector(".order-tracking-result-wrapper");
    const orderContentWrapper = wholeSection.querySelector(".order-content-wrapper");
    const spinner = wholeSection.querySelector(".spinner-wrapper");
    const errorMessage = wholeSection.querySelector(".error-message");

    const returnedOrder = await getOrder(contact, orderNo);

    const orderPhone = convertToSlug(returnedOrder?.shippingAddress?.phone);
    const inputPhone = convertToSlug(contact);
    
    if (returnedOrder) {
      if (!!returnedOrder.error || (!contact.includes("@") && inputPhone !== orderPhone) || (!contact.includes("@") && contact.length < 10)) {
        errorMessage.textContent = locale.not_found_message;
        spinner.classList.add("display-none");
        return;
      } else if (returnedOrder?.clickandcollect?.length > 1) {
        errorMessage.textContent = locale.not_support_message;
        spinner.classList.add("display-none");
        return;
      } else {
        orderContentWrapper.classList.remove("display-none");
        spinner.classList.add("display-none");
      }
    }

    const orderId = wholeSection.querySelector(".order-no");
    const currentStatus = wholeSection.querySelector(".order-current-status");
    const orderedDate = wholeSection.querySelector(".order-dates__date");
    const estimatedDeliveryDate = wholeSection.querySelector(".delivery-date");

    const cancelLink = wholeSection.querySelector(".cancel-link-wrapper");
    const orderTimeline = wholeSection.querySelector(".order-timeline");
    const timeStep = wholeSection.querySelector(".timeline-step");
    const timeStepReadyToShip = wholeSection.querySelector(".timeline-step.pending");
    const timeStepPacked = wholeSection.querySelector(".timeline-step.packed");
    const timeStepHandedOver = wholeSection.querySelector(".timeline-step.handed_over");
    const timeStepCompleted = wholeSection.querySelector(".timeline-step.completed");
    const timeStepCanceled = wholeSection.querySelector(".timeline-step.canceled");
    const timeStepDeliveryFailed = wholeSection.querySelector(".timeline-step.fail_delivery");
    const timeStepReturn = wholeSection.querySelector(".timeline-step.returned");
    const infoSection = wholeSection.querySelector(".info-section");
    const orderRoute = wholeSection.querySelector(".order-tracking-link");
    const recipient = wholeSection.querySelector(".recipient");
    const orderInfo = wholeSection.querySelector(".order-info");
    const orderProducts = wholeSection.querySelector(".products-list");

    const orderPrice = wholeSection.querySelector(".order-price-container");
    const orderSubtotal = orderPrice.querySelector(".order-subtotal");
    const shippingPriceLine = orderPrice.querySelector(".price-line.shipping");
    const orderShipping = orderPrice.querySelector(".order-shipping");
    const orderDiscount = orderPrice.querySelector(".order-discount");
    const orderTotal = orderPrice.querySelector(".order-total");

    // gán chung
    const shippingAddress = returnedOrder.shippingAddress;
    const hasHomeDelivery = returnedOrder.homedelivery?.length > 0;
    const hasClickAndCollect = returnedOrder.clickandcollect?.length > 0;
    const subtotalPrice = returnedOrder.lineItems.reduce((total, item) => {
      return total + Number(item.discountedTotalSet.presentmentMoney.amount);
    }, 0);
    const subtotalPriceFormat = {
      amount: subtotalPrice,
      currencyCode: returnedOrder.lineItems[0].discountedTotalSet.presentmentMoney.currencyCode
    };

    orderedDate.textContent = formatTo12HourTime(returnedOrder.createdAt).date;
    recipient.querySelector(".recipient-name").textContent = maskData(shippingAddress.name, "name");
    recipient.querySelector(".recipient-phone").textContent = maskData(shippingAddress.phone, "phone");
    recipient.querySelector(".recipient-address").textContent = `${maskData(shippingAddress.address1, "partialAddress")} ${maskData(shippingAddress.address2, "address")} ${shippingAddress.city}`;
    
    orderInfo.querySelector(".order-total-price").textContent = formatPrice(returnedOrder.totalPriceSet.presentmentMoney);
    
    const paymentMethodRaw = returnedOrder?.paymentGatewayNames[0]?.toLowerCase() || "";
    let paymentMethodLabel = locale.updating;

    if (paymentMethodRaw) {
      switch (true) {
        case paymentMethodRaw.includes("cod"):
          paymentMethodLabel = locale.method_cod;
          break;

        case paymentMethodRaw.includes("manual"):
          paymentMethodLabel = locale.method_manual;
          break;

        case paymentMethodRaw.includes("onepay") || paymentMethodRaw.includes("onepay -"):
          paymentMethodLabel = locale.method_onepay;
          break;

        case paymentMethodRaw.includes("installment"):
          paymentMethodLabel = locale.method_installment;
          break;

        case paymentMethodRaw.includes("zalopay"):
          paymentMethodLabel = locale.method_zalopay;
          break;

        case paymentMethodRaw.includes("momo"):
          paymentMethodLabel = locale.method_momo;
          break;

        default:
          paymentMethodLabel = paymentMethodRaw;
      }
    }

    orderInfo.querySelector(".order-payment-method").textContent = paymentMethodLabel;


    const rows = returnedOrder.lineItems.map(item => {
      let deliveryLabel = "";
      if (hasHomeDelivery && hasClickAndCollect) {
        deliveryLabel = item.customAttributes[0].value === "Pickup In Store"
          ? `${locale.store_pickup} ${item.customAttributes[1].value}`
          : locale.home_delivery;
      } else if (hasHomeDelivery && !hasClickAndCollect) {
        deliveryLabel = locale.home_delivery;
      } else if (!hasHomeDelivery && hasClickAndCollect) {
        deliveryLabel = `${locale.store_pickup} <span style="text-transform: capitalize">${returnedOrder.clickandcollect[0].NameStore.toLowerCase()}</span>`;
      }

      return `
        <tr>
          <td>
            <div class="product-image-name">
              <img class="order-tracking__bg-image"
                src="${item.image.url}"
                alt="${item.name}"
                style="object-position: center">
              <div>
                ${item.name}
                <span class="home-delivery">
                 ${deliveryLabel}
                </span>
                <div class="number-total">
                  <span>x${item.quantity}</span>
                  <span class="price-wrapper">
                    <span class="old-price">
                      ${item.originalUnitPriceSet.presentmentMoney.amount === item.discountedUnitPriceSet.presentmentMoney.amount 
                      ? '' : formatPrice(item.originalUnitPriceSet.presentmentMoney)}
                    </span>
                    <span class="price price-sale">${formatPrice(item.discountedUnitPriceSet.presentmentMoney)}</span>
                  </span>
                </div>
              </div>
            </div>
          </td>
          <td>${item.quantity}</td>
          <td>
            <div class="price price-sale">${formatPrice(item.discountedUnitPriceSet.presentmentMoney)}</div>
            <div class="old-price">
              ${item.originalUnitPriceSet.presentmentMoney.amount === item.discountedUnitPriceSet.presentmentMoney.amount 
              ? '' : formatPrice(item.originalUnitPriceSet.presentmentMoney)}
            </div>
          </td>
          <td class="price price-regular">${formatPrice(item.discountedTotalSet.presentmentMoney)}</td>
        </tr>
      `;
    });
    orderProducts.innerHTML = rows.join("");

    orderSubtotal.textContent = formatPrice(subtotalPriceFormat);
    orderShipping.textContent = formatPrice(returnedOrder.currentShippingPriceSet.presentmentMoney);
    orderDiscount.textContent = "- " + formatPrice(returnedOrder.totalDiscountsSet.presentmentMoney);
    orderTotal.textContent = formatPrice(returnedOrder.totalPriceSet.presentmentMoney);

    let shippingStatus;
    let currentStatusValue;

    const homeDeliveryTimeline = () => {
      if (!statusObject("handed_over", shippingStatus) && statusObject("completed", shippingStatus)) {
        orderRoute.style.pointerEvents = "none";
        orderRoute.href = "#";
        orderTimeline.contains(timeStepHandedOver) && orderTimeline.removeChild(timeStepHandedOver);
      } else if (statusObject("handed_over", shippingStatus)) {
        timeStepHandedOver.style.opacity = 1;
        orderRoute.style.pointerEvents = "auto";
        orderRoute.href = `https://ntlogistics.vn/tra-van-don.html?bill=${returnedOrder.homedelivery[0].TrackingNumber}`;
      }

      if (statusObject("canceled", shippingStatus) || statusObject("handed_over", shippingStatus) || statusObject("completed", shippingStatus) || statusObject("fail_delivery", shippingStatus) || statusObject("returned", shippingStatus)) {
        !statusObject("packed", shippingStatus) && orderTimeline.contains(timeStepPacked) 
          ? orderTimeline.removeChild(timeStepPacked) 
          : "";
      }
    }

    if (!hasHomeDelivery && !hasClickAndCollect && !returnedOrder.cancelReason && !returnedOrder.cancelledAt) {
      returnedOrder.homedelivery = [
        {
          "OrderNoBase": orderNo,
          "OrderNo": orderNo,
          "estimate_delivery_date": null,
          "TrackingNumber": null,
          "NameStore": null,
          "AddressStore": null,
          "shipping_status": [
            {
                "date": null,
                "curent_status": "pending"
            }
          ]
        }
      ];

      orderTimeline.removeChild(timeStepCanceled);
    }
    

    if ((hasHomeDelivery && !hasClickAndCollect) || (!hasHomeDelivery && !hasClickAndCollect && !returnedOrder.cancelReason && !returnedOrder.cancelledAt)) {
      shippingStatus = returnedOrder.homedelivery[0].shipping_status;
      currentStatusValue = returnedOrder.homedelivery[0].shipping_status[shippingStatus.length - 1].curent_status;

      orderId.textContent = returnedOrder.homedelivery[0].OrderNo;
      currentStatus.textContent = matchedStatus(currentStatusValue, "home_delivery") ? matchedStatus(currentStatusValue, "home_delivery").showText : currentStatusValue;
      estimatedDeliveryDate.textContent = returnedOrder.homedelivery[0].estimate_delivery_date 
        ? formatTo12HourTime(returnedOrder.homedelivery[0].estimate_delivery_date).dateTime24h
        : !!returnedOrder.cancelledAt && !!returnedOrder.cancelReason
        ? locale.canceled
        : locale.updating;
      
      homeDeliveryTimeline();
      
      orderInfo.querySelector("tbody").innerHTML += `
        <tr>
          <td>${locale.shipping_provider}</td>
          <td>Nhất Tín Logistics</td>
        </tr>
        <tr>
          <td>${locale.tracking_number}</td>
          <td class="tracking-number">
            ${
              !!returnedOrder.homedelivery[0].TrackingNumber 
                ? returnedOrder.homedelivery[0].TrackingNumber
                : locale.updating
            }
          </td>
        </tr>
      `;

    } else if (hasClickAndCollect && !hasHomeDelivery) {
      shippingStatus = returnedOrder.clickandcollect[0].shipping_status;
      currentStatusValue = returnedOrder.clickandcollect[0].shipping_status[shippingStatus.length - 1].curent_status;

      orderId.textContent = returnedOrder.clickandcollect[0].OrderNo;
      currentStatus.textContent = matchedStatus(currentStatusValue, "store_pickup") ? matchedStatus(currentStatusValue, "store_pickup").showText : currentStatusValue;
      estimatedDeliveryDate.textContent = returnedOrder.clickandcollect[0].estimate_delivery_date
        ? formatTo12HourTime(returnedOrder.clickandcollect[0].estimate_delivery_date).dateTime24h
        : !!returnedOrder.cancelledAt && !!returnedOrder.cancelReason
        ? locale.canceled
        : locale.updating;

      orderTimeline.contains(timeStepHandedOver) && orderTimeline.removeChild(timeStepHandedOver);

      orderInfo.querySelector("tbody").innerHTML += `
        <tr>
          <td>${locale.store_pickup}</td>
          <td>
            <span style="text-transform: capitalize">${returnedOrder.clickandcollect[0].NameStore.toLowerCase()}</span>
            <span class="pickup-address">${returnedOrder.clickandcollect[0].AddressStore}</span>
          </td>
        </tr>
      `;

      shippingPriceLine.style.display = "none";

    } else if (hasClickAndCollect && hasHomeDelivery) {
      shippingStatus = returnedOrder.homedelivery[0].shipping_status;
      currentStatusValue = returnedOrder.homedelivery[0].shipping_status[shippingStatus.length - 1].curent_status;

      currentStatus.textContent = matchedStatus(currentStatusValue, "home_delivery") ? matchedStatus(currentStatusValue, "home_delivery").showText : currentStatusValue;
      orderId.textContent = orderNo;
      infoSection.style.display = "none";
      cancelLink.style.marginTop = "70px";

      estimatedDeliveryDate.textContent = returnedOrder.homedelivery[0].estimate_delivery_date
        ? formatTo12HourTime(returnedOrder.homedelivery[0].estimate_delivery_date).dateTime24h
        : locale.updating;
      
      homeDeliveryTimeline();
    }

    // gán chung nhưng điều kiện ở biến
    orderId.style.color = currentStatusValue === "completed" ? "#006DA4" : "#70C028";
    const redStatus = ["canceled", "fail_delivery", "returned"];
    const blueStatus = ["pending", "ready_to_ship", "picked", "packed", "handed_over"];
    const greenStatus = ["completed"];
    currentStatus.style.color = redStatus.includes(currentStatusValue) ? "#dc0202" : greenStatus.includes(currentStatusValue) ? "#4F9F07" : "#006DA4";
    currentStatus.style.backgroundColor = redStatus.includes(currentStatusValue) ? "#dc020233" : greenStatus.includes(currentStatusValue) ? "#70C02833" : "#006DA433";

    timeStepReadyToShip.querySelector('.date').textContent = formatTo12HourTime(statusObject("pending", shippingStatus)?.date)?.dateTime;
    timeStepPacked.querySelector('.date').textContent = formatTo12HourTime(statusObject("packed", shippingStatus)?.date)?.dateTime;
    timeStepCompleted.querySelector('.date').textContent = formatTo12HourTime(statusObject("completed", shippingStatus)?.date)?.dateTime;

    statusObject("pending", shippingStatus) ? timeStepReadyToShip.style.opacity = 1 : timeStepReadyToShip.style.opacity = 0.4;
    statusObject("packed", shippingStatus) ? timeStepPacked.style.opacity = 1 : timeStepPacked.style.opacity = 0.4;
    statusObject("completed", shippingStatus) ? timeStepCompleted.style.opacity = 1 : timeStepCompleted.style.opacity = 0.4;
    statusObject("canceled", shippingStatus) ? timeStepCanceled.style.opacity = 1 : timeStepCanceled.style.opacity = 0.4;
    statusObject("fail_delivery", shippingStatus) ? timeStepDeliveryFailed.style.opacity = 1 : timeStepDeliveryFailed.style.opacity = 0.4;
    statusObject("returned", shippingStatus) ? timeStepReturn.style.opacity = 1 : timeStepReturn.style.opacity = 0.4;
    
    if ((hasClickAndCollect || hasHomeDelivery) && !statusObject("canceled", shippingStatus)) {
      orderTimeline.contains(timeStepCanceled) && orderTimeline.removeChild(timeStepCanceled);
    }
    if (statusObject("canceled", shippingStatus)) {
      !statusObject("packed", shippingStatus) && orderTimeline.contains(timeStepPacked) 
        ? orderTimeline.removeChild(timeStepPacked) 
        : "";
      !statusObject("handed_over", shippingStatus) && orderTimeline.contains(timeStepHandedOver)
        ? orderTimeline.removeChild(timeStepHandedOver)
        : "";
      
      !statusObject("completed", shippingStatus) && orderTimeline.contains(timeStepCompleted)
        ? orderTimeline.removeChild(timeStepCompleted)
        : "";

      timeStepCanceled.querySelector('.date').textContent = formatTo12HourTime(statusObject("canceled", shippingStatus)?.date)?.dateTime;
    }

    if (!statusObject("fail_delivery", shippingStatus)) {
      orderTimeline.contains(timeStepDeliveryFailed) && orderTimeline.removeChild(timeStepDeliveryFailed);
    } else {
      orderTimeline.contains(timeStepCompleted) && orderTimeline.removeChild(timeStepCompleted);
      timeStepDeliveryFailed.querySelector('.date').textContent = formatTo12HourTime(statusObject("fail_delivery", shippingStatus)?.date)?.dateTime;
    }

    if (!statusObject("returned", shippingStatus)) {
      orderTimeline.contains(timeStepReturn) && orderTimeline.removeChild(timeStepReturn);
    } else {
      timeStepReturn.querySelector('.date').textContent = formatTo12HourTime(statusObject("returned", shippingStatus)?.date)?.dateTime;
    }

    if (!hasHomeDelivery && !hasClickAndCollect && !!returnedOrder.cancelReason && !!returnedOrder.cancelledAt) {
      orderId.textContent = orderNo;
      currentStatus.style.display = "block";
      currentStatus.textContent = locale.canceled;
      currentStatus.style.color = "#dc0202";
      currentStatus.style.backgroundColor = "#dc020233";

      orderTimeline.removeChild(timeStepPacked);
      orderTimeline.removeChild(timeStepHandedOver);
      orderTimeline.removeChild(timeStepCompleted);

      timeStep.style.opacity = 1;
      timeStepReadyToShip.style.opacity = 1;
      timeStepCanceled.style.opacity = 1;

      estimatedDeliveryDate.textContent = locale.canceled
    }
  } catch (error) {
    console.error("Failed to fetch order:", error);
  }
}

fetchOrder(contact, orderNo);